export const USER_FILTERS_LOCAL_STORAGE_KEY = "shift-discovery-open-shifts-filters";

export const DEFAULT_DISTANCE_IN_MILES_FILTER = 150;
